export default {
  emptyLabel: 'Non renseigné',
};
